var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3E9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4998 18.417C22.8298 18.417 17.4165 23.8303 17.4165 30.5003C17.4165 37.1703 22.8298 42.5837 29.4998 42.5837C36.1698 42.5837 41.5832 37.1703 41.5832 30.5003C41.5832 23.8303 36.1698 18.417 29.4998 18.417ZM29.4998 23.2503C31.8319 23.2503 33.729 25.1474 33.729 27.4795C33.729 29.8116 31.8319 31.7087 29.4998 31.7087C27.1678 31.7087 25.2707 29.8116 25.2707 27.4795C25.2707 25.1474 27.1678 23.2503 29.4998 23.2503ZM29.4998 40.167C27.0469 40.167 24.1469 39.1762 22.0807 36.687C24.1972 35.0264 26.8096 34.1239 29.4998 34.1239C32.19 34.1239 34.8025 35.0264 36.919 36.687C34.8528 39.1762 31.9528 40.167 29.4998 40.167Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.08e262bff04251507e96339a0ba0657f.svg";
export { ForwardRef as ReactComponent };